import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../loader.service';
import { CommonDataProvider } from './common.data-provider';
import { CompanyService } from '../company.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { VariationGroup, VariationGroupItem } from '../../models/meal.model';

@Injectable()
export class VariationsDataProvider extends CommonDataProvider<VariationGroupItem> {
  private readonly variationsGroupsUrl = environment.apiUrl + '/admin/companies';

  constructor(
    http: HttpClient,
    private companyService: CompanyService,
    loaderService: LoaderService
  ) {
    super(http, loaderService);
  }

  getVariationGroups = (
    companyId: number = this.companyService.COMPANY_ID
  ): Observable<VariationGroup[]> =>
    this.http
      .get<VariationGroup[]>(`${this.variationsGroupsUrl}/${companyId}/variation-groups`)
      .pipe(
        map((variations: VariationGroup[]) => variations.map(this.toViewVariationGroup)),
        catchError(this.handleError)
      );

  bulkSaveVariationGroups(groups: VariationGroup[]): Observable<VariationGroup[]> {
    const backendGroups = groups.map(this.fromViewVariationGroup);

    return this.http
      .put<
        VariationGroup[]
      >(`${this.variationsGroupsUrl}/${this.companyService.COMPANY_ID}/variation-groups/bulk`, backendGroups)
      .pipe(
        map((updatedGroups: VariationGroup[]) => updatedGroups.map(this.toViewVariationGroup)),
        catchError(this.handleError)
      );
  }

  deleteVariationGroup = (id: number) =>
    this.http
      .delete(`${environment.apiUrl}/admin/variation-groups/${id}`)
      .pipe(catchError(this.handleError));

  toViewVariationGroup = (data: VariationGroup): VariationGroup => ({
    ...data,
    variations: data.variations.map(variation => ({
      ...variation,
      price: variation.price / 100
    }))
  });

  fromViewVariationGroup = (data: VariationGroup): VariationGroup => ({
    ...data,
    variations: data.variations.map(variation => ({
      ...variation,
      price: variation.price * 100
    }))
  });
}
